import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=2069d222&scoped=true"
import script from "./login-dialog.vue?vue&type=script&lang=js"
export * from "./login-dialog.vue?vue&type=script&lang=js"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=2069d222&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069d222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2069d222')) {
      api.createRecord('2069d222', component.options)
    } else {
      api.reload('2069d222', component.options)
    }
    module.hot.accept("./login-dialog.vue?vue&type=template&id=2069d222&scoped=true", function () {
      api.rerender('2069d222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/login-dialog.vue"
export default component.exports